import React, { useState, useRef } from 'react';
import { Breadcrumb, Row, Col, Input, Button, List, Upload, Modal, message, Spin, Progress } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import IconIos from '../../../../static/img/icon-type-ios.png';
import IconAndroid from '../../../../static/img/icon-type-android.png';
import axios from 'axios';
import Client from '../../../../lib/gqlClient';
import { GetAppInfoList, UploadApp, GetAppProject, GetMembersList } from '../gqls'
import AppProjectPage from './appProject';
import VersionItemPage from './versionItem';
import PermissionManagementPage from './PermissionManagement';
import IntegrationPage from './Integration';
import QRCode from 'qrcode.react';
window.Buffer = window.Buffer || require("buffer").Buffer;
const AppHistoryPage = (props) => {
    const projectDetailRef = useRef(null);
    const permissionManagementRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation()
    const { state } = location
    const data = state.project

    const { TextArea } = Input;
    //顶部详情
    const [selectItem, setSelectItem] = useState('版本管理');
    const [appPlatform, setAppPlatform] = useState('');
    const [appPlatformIcon, setPlatformIcon] = useState('');
    const [packageTypeName, setPackageTypeName] = useState('');
    const [packageName, setPackageName] = useState('');
    const [totalDownload, setTotalDownload] = useState(0);
    const [minimumOSVersion, setMinimumOSVersion] = useState('');

    const [isAllowViewing, setIsAllowViewing] = useState(true);
    const [description, setDescription] = useState('');
    //上传新版本信息
    const [isUpLoadApp, setIsUpLoadApp] = useState(false);
    const [createProcess, setCreateProcess] = useState('');
    const [appFile, setFile] = useState();
    const [uploadPercent, setUploadPercent] = useState();
    const [openUpData, setOpenUpData] = useState(false);
    const [newAppIcon, setAppIcon] = useState();
    const [newAppName, setNewAppName] = useState();
    const [newVersionUrl, setNewVersionUrl] = useState('');

    const [newAppPackageName, setNewAppPackageName] = useState();
    const [newAppVersionName, setNewAppVersionName] = useState();
    const [newAppVersionCode, setNewAppVersionCode] = useState();
    const [newAppMinSdkVersion, setNewAppMinSdkVersion] = useState();
    const [newAppTargetSdkVersion, setNewAppTargetSdkVersion] = useState();

    const [newAppBuildId, setNewAppBuildId] = useState();
    const [newAppVersion, setNewAppVersion] = useState();
    const [newAppBundleVersion, setNewAppBundleVersion] = useState();
    const [newAppMinimumOsVersion, setNewAppMinimumOsVersion] = useState();
    const [newAppTeamName, setNewAppTeamName] = useState();
    const [newAppTimeTolLive, setNewAppTimeTolLive] = useState();

    //模块切换
    const [versionListView, setVersionListView] = useState('');
    // 基本信息
    const [projectName, setProjectName] = useState('')
    const [projectIcon, setProjectIcon] = useState('')
    // 版本管理
    const [isGetData, setIsGetData] = useState(false)
    const [isAllowUploadApp, setIsAllowUploadApp] = useState(false);
    const [items, setItems] = useState([]);
    const [itemSize, setItemSize] = useState(0);
    //权限控制
    const [isOpenPassword, setIsOpenPassword] = useState(false)
    //集成
    const [isIntegration, setIsIntegration] = useState('none')


    React.useEffect(() => {
        getprojectData()
        getMembersList()
        getAppProject()
        getAppInfoList()
        setQRCode();

    }, [])
    function setQRCode(){
        var url = window.location.href;
        url = url.split("appHistoryList").join("checkNewVersion?id=" + data._id);
        setNewVersionUrl(url)
        console.log(url );
    }
    function onStart() {
        props.setNewKey('developerCenter/apk/appList')
        navigate('/developerCenter/apk/appList')
    }

    function getprojectData() {
        console.log(data)
        setProjectName(data.projectName)
        setAppPlatform(data.platform)
        if (data.platform === 'IOS') {
            setPackageTypeName('BundleID')
            setPlatformIcon(IconIos)
        } else {
            setPackageTypeName('PackageName')
            setPlatformIcon(IconAndroid)
        }

    }

    function getAppInfoList() {
        setIsGetData(true)
        Client(
            GetAppInfoList,
            {
                projectId: data._id,
            },
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setItemSize(res.data.getAppInfoList.length)
                setItems(res.data.getAppInfoList)
                setIsGetData(false)
            }

        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })

    }
    function getAppProject() {
        Client(
            GetAppProject,
            {
                getAppProjectId: data._id,
            },
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setTotalDownload(res.data.getAppProject.totalDownload)
                if (res.data.getAppProject.packageName !== null) {
                    setPackageName(res.data.getAppProject.packageName)

                } else {
                    setPackageName(res.data.getAppProject.buildleID)
                }
                //可编辑成员
                const members = res.data.getAppProject.members
                const minimum = parseInt(res.data.getAppProject.minimumOSVersion)
                if (minimum > 0) {
                    setMinimumOSVersion("iOS " + minimum + "  或者更高版本")
                }
                setProjectName(res.data.getAppProject.projectName)
                setProjectIcon(res.data.getAppProject.icon)
                setDescription()
                const name = sessionStorage.getItem("userName")
                if (members.size === 0) {
                    setIsAllowUploadApp(true)
                    setIsAllowViewing(false)
                } else {
                    setIsAllowViewing(true)

                    members.map((item, index) => {
                        if (item === name) {
                            setIsAllowUploadApp(true)
                            setIsAllowViewing(false)
                        }
                    })
                }
                if (res.data.getAppProject.owner === name) {
                    projectDetailRef.current.setIsOwner('')
                } else {
                    projectDetailRef.current.setIsOwner('none')
                }

                if (res.data.getAppProject.owner === name) {
                    setIsAllowUploadApp(true)
                    setIsAllowViewing(false)
                }
                setIsOpenPassword(res.data.getAppProject.hasPassword)
                projectDetailRef.current.setData(res.data.getAppProject)
                permissionManagementRef.current.setData(res.data.getAppProject)



            }

        }).catch(e => {
            // console.log(e);
        })

    }

    function getMembersList() {
        Client(
            GetMembersList,
        ).then((res) => {
            console.log(res)
            if (res !== null) {

                var list = [{}]
                res.data.getMembersList.map((item, index) => {
                    list[index] = { value: item, label: item }
                })
                permissionManagementRef.current.setMembersLists(list)
            }

        }).catch(e => {
            // console.log(e);
        })
    }
    function onShowDetails() {
        setSelectItem('基本信息')
        projectDetailRef.current.setDetails('')
        setVersionListView('none')
        permissionManagementRef.current.setProjectInfoViewShow('none')
        setIsIntegration('none')

    }
    function onShowVersionList() {
        setSelectItem('版本管理')
        projectDetailRef.current.setDetails('none')
        setVersionListView('')
        permissionManagementRef.current.setProjectInfoViewShow('none')
        setIsIntegration('none')
    }
    function onShowAppInfoView() {
        setSelectItem('权限控制')
        projectDetailRef.current.setDetails('none')
        setVersionListView('none')
        permissionManagementRef.current.setProjectInfoViewShow('')
        setIsIntegration('none')
    }
    function onShowIntegrationView() {
        setSelectItem('集成')
        projectDetailRef.current.setDetails('none')
        setVersionListView('none')
        permissionManagementRef.current.setProjectInfoViewShow('none')
        setIsIntegration('')
    }
    function onStartCheckNewVersionPage() {
        var url = window.location.href;
        url = url.split("appHistoryList").join("checkNewVersion?id=" + data._id);
        window.open(url , '_blank', 'noopener,noreferrer');

    }
    const up = {
        name: 'file',
        maxCount: 1,
        showUploadList: false,
        beforeUpload: file => {
            const name = file.name
            if (name.substring(name.length - 3, name.length) === "apk") {
                //解析android
                const ApkParser = require('app-info-parser/src/apk')
                const parser = new ApkParser(file)
                parser.parse().then(result => {
                    console.log('app info ----> ', result)
                    console.log('icon base64 ----> ', result.icon)
                    if (appPlatform === 'ANDROID') {
                        if (result.package === packageName) {
                            setNewAppName('app(' + result.versionName + ")")
                            setAppIcon(result.icon)
                            setNewAppPackageName(result.package)
                            setNewAppVersionName(result.versionName)
                            setNewAppVersionCode(result.versionCode.toString())
                            setNewAppMinSdkVersion(result.usesSdk.minSdkVersion.toString())
                            setNewAppTargetSdkVersion(result.usesSdk.targetSdkVersion.toString())
                            setUploadPercent(0)
                            setIsUpLoadApp(false)
                            setOpenUpData(true)
                        } else {
                            message.error('Installation package and project do not match')
                        }
                    } else {
                        message.error('Please select the installation package for the corresponding platform')
                    }


                }).catch(err => {
                    console.log('err ----> ', err)
                })
            } else if (name.substring(name.length - 3, name.length) === "ipa") {
                //解析ios
                const IpaParser = require('app-info-parser/src/ipa')
                const parser = new IpaParser(file)
                parser.parse().then(result => {
                    console.log('app info ----> ', result)
                    console.log('icon base64 ----> ', result.icon)
                    if (appPlatform === 'IOS') {
                        if (result.CFBundleIdentifier === packageName) {
                            setNewAppName('app(' + result.CFBundleShortVersionString + ")")
                            setAppIcon(result.icon)
                            setNewAppBuildId(result.CFBundleIdentifier)
                            setNewAppVersion(result.CFBundleShortVersionString)
                            setNewAppBundleVersion(result.CFBundleVersion)
                            setNewAppMinimumOsVersion(result.MinimumOSVersion)
                            setNewAppTeamName(result.mobileProvision.TeamName)
                            setNewAppTimeTolLive(result.mobileProvision.TimeToLive.toString())
                            setUploadPercent(0)
                            setIsUpLoadApp(false)
                            setOpenUpData(true)
                        } else {
                            message.error('Installation package and project do not match')
                        }
                    } else {
                        message.error('Please select the installation package for the corresponding platform')
                    }

                }).catch(err => {
                    console.log('err ----> ', err)
                })
            }
            setFile(file);
            return false;
        }
    };
    const showInpValue = e => {
        setDescription(e.target.value);
    }
    const onUpApp = () => {
        uploadApp(data._id);
    };

    function uploadApp(projectId) {
        setIsUpLoadApp(true)
        setCreateProcess('Create application version')
        Client(
            null,
            {
                projectId: projectId,
                platform: appPlatform,
                fileName: newAppName,
                size: appFile.size,
                description: description,
                icon: newAppIcon,
                buildleId: newAppBuildId,
                version: newAppVersion,
                bundleVersion: newAppBundleVersion,
                minimumOsVersion: newAppMinimumOsVersion,
                teamName: newAppTeamName,
                timeTolLive: newAppTimeTolLive,
                packageName: newAppPackageName,
                versionName: newAppVersionName,
                versionCode: newAppVersionCode,
                minSdkVersion: newAppMinSdkVersion,
                targetSdkVersion: newAppTargetSdkVersion
            },
            UploadApp
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                upApp(res.data.uploadApp.url)
            }

        }).catch(e => {
            // console.log(e);
            setIsUpLoadApp(false)
        })

    }
    function upApp(url) {
        setCreateProcess('Upload application version')
        axios.put(url
            , appFile, {
            headers: {
                'Content-Type': 'text/plain',
            }, transformRequest: [function (data) {
                return data
            }],
            onUploadProgress: progressEvent => {
                let complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
                console.log(complete)
                setUploadPercent(complete)
            }
        }).then((res) => {
            console.log('upload successfully.', res)
            message.success('upload successfully.')
            setOpenUpData(false)
            getAppInfoList()
        }).catch((error) => {
            console.log('upload failed.', error)
            setIsUpLoadApp(false)
            message.success('upload failed:' + error)
        });
    }



    function onRefresh() {
        getAppInfoList()
    }

    return (
        <div style={{ height: '100%', width: '100%', }}>
            <div style={{ height: '200px', backgroundColor: 'white', borderRadius: '2px' }}>
                {/* 标题头 */}
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>APK distribution platform</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart}>App List</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>APK History</a></Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{ fontSize: '20px', marginTop: '20px', marginLeft: '80px' }}>
                    <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div>
                            <img src={projectIcon} style={{ width: '100px', height: '100px', borderRadius: "8px", }} />
                            <div style={{ minWidth: '100px', textAlign: 'center', marginTop: '5px' }}>
                                {projectName}
                            </div>
                        </div>
                    </Col>
                    <Col style={{width:'100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <div onClick={() => onStartCheckNewVersionPage()} style={{marginTop: '10px'}}>
                            <QRCode
                                value={newVersionUrl}
                                size={80} // 二维码的大小   
                            />
                            <div style={{  textAlign: 'center', marginTop: '5px' }}>
                                最新版本
                            </div>
                        </div>
                    </Col>
                    <Col style={{ marginLeft: '30px' }}>
                        <Row style={{ fontSize: '16px', color: 'rgba(61, 61, 61, 0.5)' }}>

                            <Row style={{ marginLeft: '6px', paddingLeft: '5px', paddingRight: '5px', resize: 'none', borderRadius: "4px", border: '1px solid rgba(0, 0, 0, 0.2)' }}>
                                <img style={{ width: '15px', height: '15px', marginTop: '5px' }} src={appPlatformIcon} />
                                <div style={{ marginLeft: '5px', marginRight: '5px', width: '1px', height: '25px', background: '#D8D8D8' }} />
                                <div>{totalDownload}</div>
                            </Row>
                            <Col style={{ marginLeft: '6px', paddingLeft: '5px', paddingRight: '5px', resize: 'none', borderRadius: "4px", border: '1px solid rgba(0, 0, 0, 0.2)' }}>
                                {appPlatform}
                            </Col>
                            <Row style={{ marginLeft: '6px', paddingLeft: '5px', paddingRight: '5px', resize: 'none', borderRadius: "4px", border: '1px solid rgba(0, 0, 0, 0.2)' }}>
                                <div>{packageTypeName}</div>
                                <div style={{ marginLeft: '5px', marginRight: '5px', width: '1px', height: '25px', background: '#D8D8D8' }} />
                                <div>{packageName}</div>
                            </Row>
                            <Col style={{ display: appPlatform === 'IOS' ? '' : 'none', marginLeft: '6px', paddingLeft: '5px', paddingRight: '5px', resize: 'none', borderRadius: "4px", border: '1px solid rgba(0, 0, 0, 0.2)' }}>
                                {minimumOSVersion}
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <div style={{ height: '85px', width: '1px', background: '#D8D8D8' }}></div>
                            <Button onClick={() => onShowDetails()} type="text"
                                style={{ color: selectItem === '基本信息' ? '#FF5300' : '#3d3d3d', fontSize: '18px', border: 'none', height: '85px', width: '108px', display: 'flex', justifyContent: 'center', paddingTop: '60px' }}>
                                基本信息</Button>
                            <div style={{ height: '85px', width: '1px', background: '#D8D8D8' }}></div>
                            <Button onClick={() => onShowVersionList()} type="text"
                                style={{ color: selectItem === '版本管理' ? '#FF5300' : '#3d3d3d', fontSize: '18px', border: 'none', height: '85px', width: '108px', display: 'flex', justifyContent: 'center', paddingTop: '60px' }}>
                                版本管理</Button>
                            <div style={{ height: '85px', width: '1px', background: '#D8D8D8' }}></div>
                            <Button onClick={() => onShowAppInfoView()} disabled={isAllowViewing} type="text"
                                style={{ color: selectItem === '权限控制' ? '#FF5300' : '#3d3d3d', fontSize: '18px', border: 'none', height: '85px', width: '108px', display: 'flex', justifyContent: 'center', paddingTop: '60px' }}>
                                权限控制 </Button>
                            <div style={{ height: '85px', width: '1px', background: '#D8D8D8' }}></div>
                            <Button onClick={() => onShowIntegrationView()} disabled={isAllowViewing} type="text"
                                style={{ color: selectItem === '集成' ? '#FF5300' : '#3d3d3d', fontSize: '18px', border: 'none', height: '85px', width: '108px', display: 'flex', justifyContent: 'center', paddingTop: '60px' }}>
                                集成 </Button>
                            <div style={{ height: '85px', width: '1px', background: '#D8D8D8' }}></div>

                            <div style={{ height: '85px', width: '1px', background: '#D8D8D8' }}></div>

                            <Upload {...up} >
                                <Button style={{ marginLeft: '50px', display: isAllowUploadApp ? '' : 'none', marginTop: '40px', borderRadius: '8px', height: '46px', width: '160px', background: '#FF5300', color: 'white', }}>
                                    上传新版本
                                </Button>
                            </Upload>
                            <Modal
                                centered
                                open={openUpData}
                                footer={null}
                                onCancel={(e) => { setOpenUpData(false) }}
                                width={600}
                                destroyOnClose={true}
                                maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                                bodyStyle={{ padding: '0px', width: '600px', height: '600px', background: 'ffffff', borderRadius: '10px' }}
                                style={{ borderRadius: "10px", overflow: "auto" }}>
                                <div style={{ height: '30px' }}>
                                    {/* 退出 */}
                                </div>
                                <Row style={{ height: '100px', marginTop: '30px' }}>
                                    <Col style={{ marginLeft: '50px' }}>
                                        <img style={{ width: '100px', height: '100px', borderRadius: "10px", }}
                                            src={newAppIcon} />
                                    </Col>
                                    <Col style={{ marginLeft: '30px' }}>
                                        <div style={{ marginLeft: '15px', marginTop: '5px', fontSize: '18px', color: 'rgba(0, 0, 0, 0.4)' }}>
                                            {appPlatform === 'IOS' ? newAppVersion + '(Build ' + newAppBundleVersion + ")" : newAppVersionName + '(Build ' + newAppVersionCode + ")"}
                                        </div>
                                        <div style={{ marginLeft: '15px', marginTop: '10px', paddingLeft: '10px', display: 'flex', alignItems: 'center', fontSize: '20px', color: 'rgba(0, 0, 0, 0.5)', width: '355px', height: '46px', borderRadius: "4px", border: '1px solid rgba(0, 0, 0, 0.2)' }}>
                                            {newAppName}
                                        </div>

                                    </Col>
                                </Row>
                                <div style={{ marginTop: '49px', height: '1px', width: '600px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                                <Row style={{ height: '240px', marginTop: '40px', }}>
                                    <Col style={{ width: '150px', textAlign: 'right', color: 'rgba(0, 0, 0, 0.45)', fontSize: '18px' }}>
                                        更新日志
                                    </Col>
                                    <Col style={{ marginLeft: '45px', width: '355px', height: '200px', textAlign: 'right', fontSize: '18px', borderRadius: "4px", border: '1px solid rgba(0, 0, 0, 0.2)' }}>
                                        <TextArea value={description}
                                            onChange={showInpValue}
                                            style={{ width: '355px', height: '200px', resize: 'none', }} bordered={false} />
                                    </Col>
                                </Row>
                                <div style={{ marginTop: '5px', marginBottom: '10px', textAlign: 'center', color: '#FF5300', fontSize: '16px' }}>若集成新版本提醒功能，请查看集成模块的操作指南</div>

                                <div style={{ display: isUpLoadApp ? 'none' : '', }}>
                                    <div onClick={() => onUpApp()} style={{
                                        width: '600px', height: '70px', backgroundColor: '#FF5300',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        <div style={{ color: '#ffffff', fontSize: '20px', }}>
                                            开始上传
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: isUpLoadApp ? '' : 'none', }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <div style={{ marginTop: '15px', height: '15px' }}>
                                            {createProcess}
                                        </div>
                                    </div>
                                    <Progress style={{ marginLeft: '18px', width: '564px', marginRight: '18px' }}
                                        status="active" percent={uploadPercent} type="line" strokeColor='#FF5300' strokeWidth='15px' showInfo={false} />


                                </div>
                            </Modal>
                        </Row>

                    </Col>
                
                </Row>
            </div>
            {/* 基本详情 */}
            <AppProjectPage
                ref={projectDetailRef}
            />
            {/* 版本管理 */}
            <Spin size="large" tip="Loading..." spinning={isGetData} >
                <List
                    dataSource={items}
                    renderItem={(item, index) => (
                        <List.Item style={{ padding: '0px' }}>
                            <VersionItemPage
                                item={item}
                                index={index}
                                projectName={projectName}
                                hasPassword={isOpenPassword}
                                icon={projectIcon}
                                isAllowEditing={!isAllowUploadApp}
                                itemSize={itemSize}
                                onRefresh={onRefresh}
                            />
                        </List.Item>

                    )}
                    style={{ marginLeft: '30px', marginTop: '30px', display: versionListView }}
                />
            </Spin>
            {/* 权限管理 */}
            <PermissionManagementPage
                ref={permissionManagementRef}
            />
            <IntegrationPage
                isIntegration={isIntegration}
                projectName={projectName}
            />
        </div>
    );
}

export default AppHistoryPage